// extracted by mini-css-extract-plugin
module.exports = {"container":"_82e3db2ea0--container--eBHuX","phone":"_82e3db2ea0--phone--eP4T3","accordion-content":"_82e3db2ea0--accordion-content--neAS_"};